<template>
  <Modal v-model="partialCancellationModal" :title="$t('key1006141')" width="1200" :transfer="false"
    :mask-closable="false" @on-visible-change="partialCancellationChange">
    <Form class="table_box" ref="tableForm" :model="tableForm" @submit.native.prevent>
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="560"
        :loading="tableLoading"
        :span-method="handleSpan"
        :columns="tableColumns"
        :data="tableForm.tableData">
        <!--取消数量-->
        <template #cancelQuantity="{row, index}">
          <FormItem
            v-if="row.abnormalStatus === 2"
            :prop="`tableData.${index}.cancelQuantity`"
            :rules="[{ required: true, message: $t('key1006140')}]">
            <InputNumber
              :max="tableForm.tableData[index].outOfStockQuantity"
              :min="1"
              style="width: 100px"
              :formatter="value => `${parseInt(value)}`"
              v-model.trim="tableForm.tableData[index].cancelQuantity">
            </InputNumber>
          </FormItem>
          <span v-else-if="row.abnormalStatus === 3">{{ row.outOfStockQuantity }}</span>
          <span v-else>-</span>
        </template>
      </Table>
    </Form>
    <template #footer>
      <div class="flex align-items-center justify-content-between">
        <span>{{ $t('key1000234') + detailsData.refundAmountCurrency + ' ' + (totalRefundAmount || 0.00) }}</span>
        <div class="flex align-items-center">
          <Button class="mr15" @click="partialCancellationModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="partialCancellationBtn"
            :disabled="tableForm.tableData.length <=0 && confirmCancellationTalg">{{ $t('key1004292') }}</Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel} from "@/utils/common";

export default {
  name: 'partialCancellationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      partialCancellationModal: false,
      tableForm: {
        tableData: [],
      },
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let imgPath = '';
            if (params.row._productInfo) {
              let skuImgPath = params.row._productInfo.primaryImage;
              let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
              imgPath = skuImgPath ? skuImgPath : spuImgPath;
            }
            let list = [
              v.tableImg(h, params, 'primaryImage', imgPath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 170,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let list = [];
            let ymsSku = params.row.ymsSku;
            let productGoodsSpecifications = params.row.productGoodsSpecifications || [];
            if (productGoodsSpecifications.length > 0) {
              list = productGoodsSpecifications.map((item) => {
                return item.value;
              });
            }
            return h('div', [
              h('p', {class: 'mt2 mb2'}, ymsSku),
              h('p', {class: 'mt2 mb2 color-green'}, list.join(' • '))
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005924'),
          key: 'productGoodsCost',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            let productGoodsCost = params.row.productGoodsCost || 0;
            let currency = params.row.currency || v.currencyState;
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, currency),
              h('div', v.formatCurrency(productGoodsCost)),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110'),
          key: 'abnormalStatus',
          align: 'left',
          minWidth: 180,
          render: (h, params) => {
            let abnormalStatus = params.row.abnormalStatus;  // 1.待供应商接单 2.缺货-补货中 3.缺货-已停售
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ?
              v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            return h('div', [
              // 待供应商接单
              abnormalStatus === 1 ? h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006137')) : '',
              // 缺货-补货中
              abnormalStatus === 2 ? h('div', {class: 'crimsonRedColor'}, [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004364')),
                estimateArrivalOfGoodsTime ? h('p', {class: 'crimsonRedColor mt4 flex flex-direction'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                  h('span', estimateArrivalOfGoodsTime)
                ]) : '',
              ]) : '',
              // 商品已停售
              abnormalStatus === 3 ? h('div', {class: 'flex flex-direction crimsonRedColor'}, [
                h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536')),
                h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006138'))
              ]) : '',
              ![1, 2, 3].includes(abnormalStatus) ? h('span', '-') : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005925'),
          key: 'quantity',
          minWidth: 110,
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000524'),
          key: 'outOfStockQuantity',
          minWidth: 110,
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317'),
          key: 'cancelQuantity',
          minWidth: 130,
          align: 'left',
          slot: 'cancelQuantity'
        },
      ],
      ymsStockUpInfoId: null,
      detailsData: {},
      totalRefundAmount: 0,
      confirmCancellationTalg: false,
    };
  },
  methods: {
    // 初始化数据
    initPartialCancellationData(ymsStockUpInfoId) {
      this.ymsStockUpInfoId = ymsStockUpInfoId;
      this.getStockListItemInfo(ymsStockUpInfoId);
      this.partialCancellationModal = true;
    },
    // 获取备货单货品信息
    getStockListItemInfo(ymsStockUpInfoId) {
      let ymsProductGoodsIds = [];
      this.axios.get(api.get_ymsDistributorStockUpInfo + `${ymsStockUpInfoId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let currency = data.refundAmountCurrency || this.currencyState;
            data.refundAmountCurrency = currency;
            this.detailsData = data;
            // 处理货品信息
            let ymsStockUpGoods = data.ymsStockUpGoods || [];
            if (ymsStockUpGoods.length > 0) {
              ymsStockUpGoods.map((item) => {
                ymsProductGoodsIds.push(item.ymsProductGoodsId);
              });
            }
            if (ymsProductGoodsIds.length > 0) {
              this.getProductInfoByIds(ymsProductGoodsIds, ymsStockUpGoods).then((newData) => {
                if (newData && newData.length > 0) {
                  newData.map((item) => {
                    item.ymsSpu = item._productInfo ? item._productInfo._spuInfo ? item._productInfo._spuInfo.ymsSpu : null : null;
                    item.cancelQuantity = null;
                  });
                  this.handleTableData(newData);
                }
              });
            }
          }
        }
      });
    },
    // 处理列表数据,按照SPU维度合并行数据
    handleTableData(data) {
      let v = this;
      let newList = [];
      if (data.length > 0) {
        let newData = v.handerGrouping(data, function (item) {
          return [item.ymsSpu];
        }, 'ymsSpu', 'ymsSkuList');
        if (newData.length > 0) {
          newData.map((ele) => {
            let length = ele.ymsSkuList.length;
            ele.ymsSkuList.map((talg, index) => {
              talg['length'] = length;
              talg['currentTalg'] = (length > 1 && index === 0);
              newList.push(talg);
            });
          });
        }
        if (newList.length > 0) {
          newList.map((item, index) => {
            item['tableLength'] = newList.length;
            if (item.currentTalg) {
              item['currentIndex'] = index;
            }
          });
          v.tableForm.tableData = newList;
          if (v.tableForm.tableData.length > 0) {
            v.$nextTick(() => {
              setTimeout(() => {
                if (v.$refs['tableDom']) {
                  v.$refs['tableDom'].$el.querySelector('.ivu-table-body').scrollTop = 0;
                }
                v.tableForm.tableData = [...v.tableForm.tableData];
              }, 1000);
            });
            v.$forceUpdate();
          }
          v.$forceUpdate();
        }
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let handleKeyList = ['skuInfo', 'productGoodsCost', 'abnormalStatus', 'quantity', 'outOfStockQuantity', 'cancelQuantity'];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (!handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
        });
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
    // 确认取消
    partialCancellationBtn() {
      let v = this;
      let query = {
        cancelDistributorStockUpGoodsBos: [],
        ymsStockUpInfoId: v.ymsStockUpInfoId
      };
      if (v.tableForm.tableData.length > 0) {
        let newData = JSON.parse(JSON.stringify(v.tableForm.tableData));
        if (newData.length > 0) {
          newData.map((item) => {
            if([2,3].includes(item.abnormalStatus)) {
              query.cancelDistributorStockUpGoodsBos.push({
                ymsProductGoodsId: item.ymsProductGoodsId,
                originalTotalQuantity: item.quantity,
                cancelQuantity: item.abnormalStatus === 3 ? item.outOfStockQuantity : item.cancelQuantity,
              });
            }
          });
        }
        v.$refs['tableForm'].validate((valid) => {
          if (valid) {
            v.axios.post(api.post_ymsDistributorStockUpInfo_confirmCancel, query,
              {loading: true, loadignText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006139'));
                v.partialCancellationModal = false;
                v.$emit('updateData', true);
              }
            });
          }
        });
      }
    },
    // 监听弹窗
    partialCancellationChange(val) {
      if (!val) {
        this.detailsData = {};
        this.tableForm.tableData = [];
        this.ymsStockUpInfoId = null;
        this.confirmCancellationTalg = false;
      }
    }
  },
  watch: {
    'tableForm.tableData': {
      handler(data) {
        this.totalRefundAmount = 0;
        data.map((item) => {
          item.refundAmounts = item.productGoodsCost * item.cancelQuantity;
        });
        let totalRefundAmount = data.reduce((acc, item) => acc + item.refundAmounts, 0);
        this.totalRefundAmount = amountHandel(totalRefundAmount);
        this.confirmCancellationTalg = data.every((ele) => {
          return ele.abnormalStatus !== 2;
        });
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less">

</style>
